import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import "./App.css";
import Clients from "./components/clients";
import Contact from "./components/contact";
import ContactForm from "./components/contactForm";
import Home from "./components/home";
import Layout from "./components/layout";
import PrivacyPolicy from "./components/privacyPolicy";
import Services from "./components/services";
import WhoWeAre from "./components/whoWeAre";

function App() {
    return (
        <ParallaxProvider>
            <Toaster
                position="top-center"
                reverseOrder={false}
            />
            <BrowserRouter basename="/">
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Home />} />
                        <Route path="who-we-are" element={<WhoWeAre />} />
                        <Route path="clients" element={<Clients />} />
                        <Route path="contact" element={<Contact />} />
                        <Route path="contact-form" element={<ContactForm />} />
                        <Route path="services" element={<Services />} />
                        <Route path="privacy" element={<PrivacyPolicy />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </ParallaxProvider>
    );
}

export default App;
